import React from 'react';
import { createRoot } from 'react-dom/client';
import LandingPage from '../components/LandingPage.jsx';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('react-landing-root');
  if (container) {
    const root = createRoot(container);
    root.render(<LandingPage />);
  }
});
